module.exports = __webpack_public_path__ + "img/codepen_h.67eec1d3.svg";